import React from "react";

const Lentil = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Lentil</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg table-responsive"
        style={{ textAlign: "justify" }}
      >
        <table className=" table table-striped table-bordered">
        <thead className="text-center">
            <tr>
              <th>Seed Rate</th>
              <th>Sowing Time</th>
              <th>Irrigation</th>
              <th>Maturity Time</th>
              <th>Characterstics</th>
              <th>Average Yield</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="6">
                <strong>SAPNA [Released in 22.11.1991]</strong>
              </td>
            </tr>
            <tr>
              <td>18 to 20 kgs per acre</td>
              <td>November to Ist week of December</td>
              <td>2-3</td>
              <td>140 days</td>
              <td>
                Hard &amp; Bold grain. Resistant to rust. Suitable for fertile
                &amp; irrigated areas.
              </td>
              <td>6 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>Garima LH 82-6</strong>
              </td>
            </tr>
            <tr>
              <td>18 to 20 kgs per acre</td>
              <td>November to Ist week of December</td>
              <td>2-3</td>
              <td>145 days</td>
              <td>
                Plant height 50.6 cm. Suitable for Haryana State. Hard &amp;
                Bold grain.
              </td>
              <td>6 quintals per acre</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Lentil;
